import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Stack,
  Chip,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  InsertDriveFile as FileIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { FileUploadItemProps } from './types';
import { useFileUploadItem } from './useFileUploadItem';
import './FileUploadItem.scss';

const FileUploadItem: React.FC<FileUploadItemProps> = props => {
  const { showFileType = true, showFileSize = true, customStyles } = props;

  const { handleDelete, getFileTypeDisplayName, disabled } =
    useFileUploadItem(props);

  return (
    <Paper
      elevation={0}
      className={`fileUploadItem ${disabled ? 'fileUploadItem--disabled' : ''}`}
      style={customStyles?.container}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <FileIcon className="fileUploadItem__icon" />

        <Box className="fileUploadItem__content">
          <Typography
            variant="subtitle2"
            className="fileUploadItem__name"
            noWrap
            title={props.file.name}
          >
            {props.file.name}
          </Typography>

          {(showFileSize || showFileType) && (
            <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
              {showFileSize && (
                <Chip
                  label={props.file.size}
                  size="small"
                  variant="filled"
                  className="fileUploadItem__chip"
                />
              )}
              {showFileType && (
                <Chip
                  label={getFileTypeDisplayName()}
                  size="small"
                  variant="filled"
                  className="fileUploadItem__chip"
                />
              )}
            </Stack>
          )}
        </Box>

        <Tooltip title="Remove file">
          <IconButton
            onClick={handleDelete}
            disabled={disabled}
            size="small"
            className={`fileUploadItem__deleteButton ${disabled ? 'fileUploadItem__deleteButton--disabled' : ''}`}
            style={customStyles?.deleteButton}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
    </Paper>
  );
};

export default FileUploadItem;
